<template>
    <div class="mobile-menu md:hidden">
        <div class="mobile-menu-bar">
            <NavLink
                :href="route('dashboard')"
                class="flex mr-auto"
            >
                Tax Clinic
            </NavLink>
            <a
                href="javascript:;"
                id="mobile-menu-toggler"
            >
                <i
                    data-feather="bar-chart-2"
                    class="w-8 h-8 text-white transform -rotate-90"
                ></i>
            </a>
        </div>
        <ul class="border-t border-theme-24 py-5 hidden">
            <MobileSidebarLink
                v-for="link in links"
                v-show="checkPermission(link, $page)"
                :href="route(link.href, link.options || {})"
                :component="link.component"
                :title="link.title"
                :icon="link.icon"
            />
        </ul>
    </div>

</template>

<script setup>
import links from '../json/sidebar-links.json';
import MobileSidebarLink from "./MobileSidebarLink";

const checkPermission = (link, page) => {
    if (!link.auth) {
        return true;
    }
    return page.props.auth.user.isAdmin;
};
</script>
